import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const MobileFriendlyEcommerceWebDesignInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Mobile-friendly E-commerce Web Design in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Shop Anywhere, Anytime</Subheading>}
        heading={
          <Heading>
            Mobile-friendly{" "}
            <span tw="text-primary-500">E-commerce Web Design</span> in Al
            Barsha
          </Heading>
        }
        description={
          <Description>
            MilaajBrandset specializes in mobile-friendly e-commerce web design
            in **Al Barsha**, creating responsive online stores that deliver
            seamless shopping experiences on any device.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1593642702821-c8da6771f0c6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile shopping experience
          "https://images.unsplash.com/photo-1616469829941-c7200edec809?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile e-commerce development
          "https://images.unsplash.com/photo-1556740772-1a741367b93e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Customer using mobile shopping app
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Optimize Your Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Mobile Matters</Subheading>}
        heading="Responsive E-commerce Solutions"
        description="Our mobile-friendly designs drive engagement and sales."
        cards={[
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Responsive Layouts",
            description: "Perfect on phones and tablets.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Easy Checkout",
            description: "Streamlined for mobile users.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Loading",
            description: "Optimized for mobile speed.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Transactions",
            description: "Safe shopping on the go.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Custom Mobile UX",
            description: "Tailored for your audience.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Al Barsha Leaders",
            description: "Trusted mobile experts.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Design</Subheading>}
        heading="Our Mobile-friendly Development Process"
        description={
          <Description>
            We build stores that shine on mobile:
            <ul tw="mt-4 list-disc pl-6">
              <li>Research: Analyze mobile user behavior.</li>
              <li>Design: Create responsive, intuitive layouts.</li>
              <li>Development: Code for speed and compatibility.</li>
              <li>Testing: Validate across devices and browsers.</li>
              <li>Launch: Deliver a mobile-optimized store.</li>
              <li>Support: Enhance based on analytics.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1555774698-0b77e0d5fac6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile website development
          "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Team collaborating on mobile design
          "https://images.unsplash.com/photo-1481437156560-3205f6a55735?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile responsive testing
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="Mobile-friendly Success in Al Barsha"
        description="Our responsive stores boost performance."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Mobile Sales",
            description: "40% increase in mobile purchases.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "User Retention",
            description: "25% higher return visits.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "94% positive feedback.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Mobile?</Subheading>}
        heading="Mobile-friendly E-commerce Web Design in Al Barsha"
        description={
          <Description>
            MilaajBrandset delivers mobile-friendly e-commerce web design in Al
            Barsha, ensuring your store excels on every device. Contact us to
            optimize your mobile presence today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1586880244406-556ebe35f282?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile e-commerce success
          "https://images.unsplash.com/photo-1559526324-593bc073d938?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Dubai skyline with person using smartphone
          "https://images.unsplash.com/photo-1611162618071-b39a2ec055fb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile payment/checkout
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
